import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {
    MatListItemIcon,
    MatListItemLine,
    MatListItemTitle,
    MatListOption,
    MatSelectionList,
} from '@angular/material/list';

import {Tag} from '@app/tag/models';

@Component({
    selector: 'frog-merge-tag-dialog',
    templateUrl: './merge-tag-dialog.component.html',
    styleUrls: ['./merge-tag-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatSelectionList,
        MatListOption,
        MatIcon,
        MatListItemIcon,
        MatListItemTitle,
        MatListItemLine,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class MergeTagDialogComponent implements OnInit {
    @ViewChild('tagList') tagList: MatSelectionList;
    public tags: Tag[];

    constructor(
        public dialogRef: MatDialogRef<MergeTagDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Tag[],
    ) {
        this.tags = data.slice();
    }

    ngOnInit(): void {}

    drop(event: CdkDragDrop<Tag[]>) {
        moveItemInArray(this.tags, event.previousIndex, event.currentIndex);
    }

    save() {
        const tagIds = [this.tagList.selectedOptions.selected[0].value.id];
        for (let i = 0; i < this.tags.length; i++) {
            if (!tagIds.includes(this.tags[i].id)) {
                tagIds.push(this.tags[i].id);
            }
        }
        this.dialogRef.close(tagIds);
    }
}
